import {FC, useState} from "react";
import {EditableStatistic} from "../../../../components/EditableStatistic/EditableStatistic.tsx";
import {EventPatch} from "../../../../types/domain.ts";
import dayjs from "dayjs";

type Props = {
    title: string;
    name: keyof EventPatch;
    defaultValue: string;
    editable: boolean;
    onChange: (name: keyof EventPatch, value: string) => void;
    preLine?: boolean;
}

export const EventEditableStatistic: FC<Props> = ({ title, name, defaultValue, editable, onChange, preLine }) => {
    const [value, setValue] = useState(defaultValue);

    if(name === 'date') {
        return (
            <EditableStatistic.Date
                title={title}
                value={dayjs.utc(value, 'YYYY-MM-DD')}
                onChange={editable ? (value) => {
                    setValue(value.format('YYYY-MM-DD'))
                    onChange(name, value.format('YYYY-MM-DD'));
                } : undefined}
            />
        )
    }

    return (
        <EditableStatistic
            title={title}
            value={value}
            onChange={editable ? (value) => {
                setValue(value);
                onChange(name, value);
            } : undefined}
            preLine={preLine}
        />
    )
}